<app-sub-header [pageTitle]="'VisualDamageAndAccidents' | translate"></app-sub-header>

<div class="padded-container">
    <dx-button 
    class="full-width-button"  
        text="{{ 'VisualDefectOrDamageDetection' | translate }}" 
        stylingMode="contained" 
        type="default" 
        (onClick)="pickVisualDamage()">
    </dx-button>
    <dx-button 
    class="full-width-button"
        text="{{ 'RegistrationOfARoadTrafficAccident' | translate }}" 
        stylingMode="contained" 
        type="default" 
        (onClick)="pickAccident()">
    </dx-button>
    <dx-button 
    class="full-width-button" 
        text="{{ 'ViewRecordedDamage' | translate }}" 
        stylingMode="contained" 
        type="default" 
        [disabled]="true">
    </dx-button>
    <dx-button 
    class="full-width-button"
        text="{{ 'Back' | translate }}"
        stylingMode="contained" 
        type="default" 
        (onClick)="backClick()">
    </dx-button>
</div>